import { render } from "./clothCard.vue?vue&type=template&id=01a344c3&scoped=true&ts=true"
import script from "./clothCard.vue?vue&type=script&lang=ts"
export * from "./clothCard.vue?vue&type=script&lang=ts"

import "./clothCard.vue?vue&type=style&index=0&id=01a344c3&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a344c3"]])

export default __exports__